import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Divider, Grid, Typography} from '@mui/material';

import {AccountManagement} from '../AccountManagement/AccountManagement';
import {ChangePasswordForm} from '../ChangePassword/ChangePasswordForm';

import LanguageSwitcher from '../../../../../../components/LanguageSwitcher/LanguageSwitcher';
import {UserContext} from '../../../../../../contexts/UserContext/UserContext';
import {PersonalTwoFactorAuthentication} from '../../../../../../features/user/twoFactor/components/PersonalTwoFactorAuthentication';

export const PersonalSettingsTab = () => {
  const {t} = useTranslation();
  const {currentUser} = useContext(UserContext);

  return (
    <Grid container spacing={4}>
      <Grid item container xs={12} marginTop={1} alignItems='baseline'>
        <Grid item>
          <Typography variant='h3' mr={2}>
            {t('settings.email')}:
          </Typography>
        </Grid>
        <Grid item sx={{wordBreak: 'break-word'}}>
          <Typography variant='body1'>{currentUser?.email}</Typography>
        </Grid>
        <Divider
          sx={{
            width: '100%',
            marginTop: '8px',
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant='h3'>{t('settings.languageSettings.title')}</Typography>
        <Typography variant='body1' gutterBottom>
          {t('settings.languageSettings.subtitle')}
        </Typography>
        <Divider
          sx={{
            width: '100%',
            marginBottom: '16px',
          }}
        />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <LanguageSwitcher />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <PersonalTwoFactorAuthentication />
      </Grid>

      <Grid item xs={12}>
        <ChangePasswordForm />
      </Grid>

      <Grid item xs={12}>
        <AccountManagement />
      </Grid>
    </Grid>
  );
};
